var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#010101","d":"M47.753,36.485l-23-26.285c-0.381-0.436-1.125-0.436-1.506,0l-23,26.285\r\n\tc-0.363,0.415-0.321,1.047,0.095,1.411c0.414,0.363,1.046,0.322,1.411-0.095L24,12.376l22.247,25.425\r\n\tc0.198,0.227,0.475,0.342,0.753,0.342c0.234,0,0.469-0.081,0.658-0.247C48.074,37.532,48.116,36.9,47.753,36.485z"}));
}

ArrowUp.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"48px","height":"48px","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48","xmlSpace":"preserve"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
